import {useContext, useState} from "react";
import {
  Box,
  Button,
  MenuItem,
  Modal,
  Stack,
  TextField,
  Typography
} from "@mui/material";
import {Context as AppContext, ProjectRoles} from "../../../../context/AppContext";
import {SignInContext} from "../../../../context/SignInContext";
import {toast} from "react-toastify";

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  maxWidth: 500,
  width: "90%",
  bgcolor: 'background.paper',
  borderRadius: 2,
  boxShadow: 24,
  p: 4,
};

export const CreateMemberModal = ({open, handleClose, project}) => {
  const {updateProject} = useContext(AppContext);
  const {organizations} = useContext(SignInContext);
  const [username, setUsername] = useState("");
  const [role, setRole] = useState("");
  const [vdn, setVdn] = useState("");

  const handleSave = () => {
    if (!username || !role) return;

    const members = project?.members || [];
    const userExist = members?.find(i => i?.username === username);
    if (userExist) {
      toast.error("User already exists")
      return;
    }
    const member = {username, role, vdn};
    members.push(member);
    const vdnManager = project?.vdnManager || {};
    vdnManager[username] = vdn;
    const team = project?.team || [];
    team.push(username);
    const newProject = {...project, members, team, vdnManager};
    try {
      updateProject({...newProject})
      toast.success("Project updated successfully")
    } catch (error) {
      toast.error(error?.message || "Failed to update project")
    }
    handleClose();
    setUsername("");
    setRole("");
    setVdn("");
  };

  const org = organizations?.find(org => org?.id === (project?.organization || project?.organization_id || project?.settings?.organization));
  const members = project?.members?.map(i => i?.username)
  console.log(org)
  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={modalStyle}>
        <Typography variant="h6" fontWeight={600} mb={2}>Add Project Member</Typography>

        <Stack direction="column" gap={2}>
          <TextField
            label="Username"
            select
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            fullWidth
          >
            {org?.members?.filter(i => !members?.includes(i?.member)).map((item) => (
              <MenuItem key={item?.member} value={item?.member}>{item?.member}</MenuItem>
            ))}
          </TextField>

          <TextField
            label="Role"
            select
            value={role}
            onChange={(e) => setRole(e.target.value)}
            fullWidth
          >
            {Object.entries(ProjectRoles).map(([key, value]) => (
              <MenuItem key={key} value={value}>{value?.toLowerCase()}</MenuItem>
            ))}
          </TextField>

          <TextField
            label="VDN Number"
            value={vdn}
            onChange={(e) => setVdn(e.target.value)}
            fullWidth
          />

          <Stack direction="row" gap={2} mt={2}>
            <Button
              onClick={handleClose} variant="ghost"
              color={"secondary"}
              fullWidth
              sx={{borderRadius: 2}}
            >
              Cancel
            </Button>
            <Button
              variant="modal"
              color={"secondary"}
              onClick={handleSave}
              disabled={!username || !role}
              fullWidth
              sx={{borderRadius: 2}}
            >
              Add Member
            </Button>
          </Stack>
        </Stack>
      </Box>
    </Modal>
  );
};
